import React from 'react';
import Slider from 'react-slick';
import './OwlSighting.scss';
import Button from '../@redantler/redantler-npm-button-react';
import { COLORS } from '../../constants/colors';
import NextArrowButton from '../UI/Icons/NextArrowButton';
import PrevArrowButton from '../UI/Icons/PrevArrowButton';

/**
 * Render Owl Sighting component with instagram posts
 * @param {String} heading
 * @param {Array} socialImages - Array of all instagram posts
 * @returns {JSX.Element}
 * @constructor
 */
const OwlSighting = ({ heading, socialImages }) => {
  const settings = {
    dots: false,
    infinite: false,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    prevArrow: (
      <Button addClass="c-owl-sighting__arrow c-owl-sighting__prev">
        <PrevArrowButton color={COLORS.white} />
      </Button>
    ),
    nextArrow: (
      <Button addClass="c-owl-sighting__arrow c-owl-sighting__next">
        <NextArrowButton color={COLORS.white} />
      </Button>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
        },
      },
    ],
  };

  return (
    <div className="c-owl-sighting background-color-green2">
      <div className="c-owl-sighting__content">
        <h4 className="c-owl-sighting__heading h2-roobert color-white">{heading}</h4>

        <div className="c-owl-sighting__posts">
          <Slider {...settings}>
            {socialImages.map((post) => (
              <div className="c-owl-sighting__post">
                <img className="c-owl-sighting__image" src={post.image.url} alt={post.image.alt} />
                <span className="c-owl-sighting__author eyebrow-2 color-white">
                  {post.instagram_username}
                </span>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default OwlSighting;
